import { SearchOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useUser } from '../../../../hooks/use_user';
import { SignupLoginModalActions } from '../../../../redux/signup_login_modal';
import { ActiveMapPageModalType } from '../../../../routes/map_page/lib/map_page_types';
import SvgAddWaypointIcon from '../../../svg/add_waypoint_icon';
import SvgLakesSolid from '../../../svg/lakes_solid';
import styles from './mobile_content_toggle_menu.less';

interface MobileContentToggleMenuProps {
  activeModal: ActiveMapPageModalType;
  isWaypointCreateMode: boolean;
  isSearchActive: boolean;
  lakesCount: number;
  onModalChange: (shouldOpen: boolean, modalType: ActiveMapPageModalType) => void;
  onWaypointCreate: () => void;
  onSearchClick: () => void;
}
export const MobileContentToggleMenu = (props: MobileContentToggleMenuProps) => {
  const {
    activeModal,
    onModalChange,
    lakesCount,
    onWaypointCreate,
    isSearchActive,
    isWaypointCreateMode,
    onSearchClick,
  } = props;

  const handleToggleClick = (
    type: ActiveMapPageModalType,
    e: React.MouseEvent<HTMLSpanElement, MouseEvent> | React.ChangeEvent<HTMLInputElement>
  ) => {
    e.stopPropagation();
    onModalChange(true, type);
  };

  const { user } = useUser();
  const dispatch = useDispatch();

  return (
    <>
      <div
        className={classNames(styles.searchButton, {
          [styles.searchButton__active]: isSearchActive,
        })}
      >
        <span onClick={onSearchClick}>
          <SearchOutlined />
        </span>
      </div>

      <div className={styles.toggleButtonsWrapper}>
        <span
          className={styles.lakesModal}
          id="lakes_input_icon"
          onClick={(e) => handleToggleClick('lakes', e)}
        >
          <input
            className={styles.radio}
            onChange={(e) => handleToggleClick('lakes', e)}
            type="radio"
            checked={activeModal === 'lakes'}
            aria-describedby={'lakes_input_icon'}
            name={'lakes'}
            hidden
          />
          <SvgLakesSolid />
          {lakesCount > 0 && <span className={styles.count}>{lakesCount}</span>}
        </span>
      </div>

      <div className={styles.waypointCreateButton}>
        <span
          onClick={(e) => {
            e.stopPropagation();
            if (!user) {
              dispatch(
                SignupLoginModalActions.SIGNUP_LOGIN_MODAL_OPEN({
                  heading: 'To Create Waypoints Sign Up or Log In',
                })
              );

              return;
            }
            if (isWaypointCreateMode) {
              return;
            }
            onWaypointCreate();
            if (activeModal === 'waypoints') {
              return;
            }
            handleToggleClick('waypoints', e);
          }}
        >
          <SvgAddWaypointIcon />
        </span>
      </div>
    </>
  );
};
